import { Card, CardContent, Division, Heading } from "@ir/ui";
import { ReactNode, memo } from "react";

interface ProgramInfoCardProps {
  title: string;
  children: ReactNode;
}

export const ProgramInfoCard = memo(({ title, children }: ProgramInfoCardProps) => (
  <Card className="bg-white mb-3">
    <CardContent className="p-0">
      <Division className="px-4 py-3">
        <Heading level={6} className="text-grey-700 font-bold m-0">
          {title}
        </Heading>
      </Division>
    </CardContent>
    {children}
  </Card>
));

ProgramInfoCard.displayName = "ProgramInfoCard";
